import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './AddWarehouseModal.css';

export default function EditWarehouseModal({ isOpen, onClose, warehouseData, onEditSuccess }) {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    location: '',
    capacity: '',
    currentStock: '',
    lat: '',
    lng: ''
  });

  useEffect(() => {
    if (warehouseData) {
      setFormData({
        id: warehouseData.id || '',
        name: warehouseData.name || '',
        location: warehouseData.location || '',
        capacity: warehouseData.capacity || '',
        currentStock: warehouseData.currentStock || '',
        lat: warehouseData.coordinates?.lat || '',
        lng: warehouseData.coordinates?.lng || ''
      });
    }
  }, [warehouseData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedWarehouse = {
      ...warehouseData,
      name: formData.name,
      location: formData.location,
      capacity: parseInt(formData.capacity) || 0,
      currentStock: parseInt(formData.currentStock) || 0,
      coordinates: {
        lat: parseFloat(formData.lat) || 0,
        lng: parseFloat(formData.lng) || 0
      }
    };

    onEditSuccess(updatedWarehouse);
    onClose();
  };

  return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Edit Warehouse</h2>
            <button className="modal-close" onClick={onClose} type="button">
              <X size={20} />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label>Warehouse ID</label>
              <input name="id" value={formData.id} disabled className="disabled-input" />
            </div>
            <div className="form-group">
              <label>Name</label>
              <input name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input name="location" value={formData.location} onChange={handleChange} required />
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label>Capacity</label>
                <input type="number" name="capacity" value={formData.capacity} onChange={handleChange} required />
              </div>
              <div className="form-group half">
                <label>Current Stock</label>
                <input type="number" name="currentStock" value={formData.currentStock} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label>Latitude</label>
                <input type="number" step="any" name="lat" value={formData.lat} onChange={handleChange} required />
              </div>
              <div className="form-group half">
                <label>Longitude</label>
                <input type="number" step="any" name="lng" value={formData.lng} onChange={handleChange} required />
              </div>
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn-submit">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
  );
}